export const SALON_HEADER_MODAL = 'SALON_HEADER_MODAL';
